import React, { useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

// Onglets contrôlables (clé = activeTab du Dashboard)
export const TOGGLEABLE_TABS = [
  { key: 'eshops-prosper', label: 'Recherche Pro' },
  { key: 'prospect-cee', label: 'Prospect CEE' },
  { key: 'leads-cee', label: 'Leads CEE' },
  { key: 'base-perso', label: 'Importer Base' },
  { key: 'prospects-extraction', label: 'Prospects Extraction' },
  { key: 'planning', label: 'Planning' },
  { key: 'planning-cee', label: 'Planning CEE' },
  { key: 'script-appel', label: "Script d'Appel" },
  { key: 'script-cee', label: 'Script CEE' },
  { key: 'clients', label: 'Gestion des Clients' },
  { key: 'compte', label: 'Gestion compte' },
];

function TabPermissionsModal({ user, onClose, onSaved }) {
  const initialHidden = Array.isArray(user.hidden_tabs)
    ? user.hidden_tabs
    : (() => { try { return JSON.parse(user.hidden_tabs || '[]'); } catch (e) { return []; } })();

  // visible[key] = true => onglet visible (donc PAS dans hidden_tabs)
  const [visible, setVisible] = useState(() => {
    const v = {};
    TOGGLEABLE_TABS.forEach(t => { v[t.key] = !initialHidden.includes(t.key); });
    return v;
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const toggle = (key) => setVisible(prev => ({ ...prev, [key]: !prev[key] }));
  const allOn = () => { const v = {}; TOGGLEABLE_TABS.forEach(t => v[t.key] = true); setVisible(v); };
  const allOff = () => { const v = {}; TOGGLEABLE_TABS.forEach(t => v[t.key] = false); setVisible(v); };

  const handleSave = async () => {
    setSaving(true); setError('');
    try {
      const hidden_tabs = TOGGLEABLE_TABS.filter(t => !visible[t.key]).map(t => t.key);
      const token = localStorage.getItem('token');
      await axios.put(`${API_URL}/api/users/${user.id}/tabs`, { hidden_tabs }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (onSaved) onSaved(user.id, hidden_tabs);
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de l\'enregistrement');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ maxWidth: '520px', width: '92vw' }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0, fontSize: '20px' }}>Autorisations d'onglets — {user.nom}</h2>
          <button className="btn-close" onClick={onClose}>&times;</button>
        </div>
        <div style={{ padding: '8px 4px' }}>
          <p style={{ color: '#666', fontSize: '13px', margin: '0 0 12px' }}>
            Cochez les onglets que cet utilisateur peut voir. Les onglets décochés seront masqués.
          </p>
          <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
            <button type="button" onClick={allOn} style={{ padding: '6px 12px', border: '1px solid #ccc', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>Tout cocher</button>
            <button type="button" onClick={allOff} style={{ padding: '6px 12px', border: '1px solid #ccc', borderRadius: '6px', background: '#fff', cursor: 'pointer' }}>Tout décocher</button>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {TOGGLEABLE_TABS.map(t => (
              <label key={t.key} style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 10px', border: '1px solid #eee', borderRadius: '8px', cursor: 'pointer', background: visible[t.key] ? '#f3f0ff' : '#fafafa' }}>
                <input type="checkbox" checked={visible[t.key]} onChange={() => toggle(t.key)} />
                <span style={{ fontSize: '14px' }}>{t.label}</span>
              </label>
            ))}
          </div>
          {error && <div className="error-message" style={{ marginTop: '12px' }}>{error}</div>}
        </div>
        <div className="modal-actions" style={{ marginTop: '8px' }}>
          <button type="button" onClick={onClose} className="btn-cancel">Annuler</button>
          <button type="button" onClick={handleSave} className="btn-save" disabled={saving}>
            {saving ? 'Enregistrement...' : 'Enregistrer'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TabPermissionsModal;
